import React from "react";
import { Minus, Plus } from "lucide-react";
import Caption from "../../../components/Typography/Caption";

interface DecimalSelectorProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
}

export const DecimalSelector: React.FC<DecimalSelectorProps> = ({
  value,
  onChange,
  min = 0,
  max = 4,
}) => {
  const handleDecrease = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  const handleIncrease = () => {
    if (value < max) {
      onChange(value + 1);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Caption className="text-[color:var(--vi-text)] font-dm font-semibold whitespace-nowrap">
        Decimals
      </Caption>
      <div className="vi-dg-control flex items-center rounded-full overflow-hidden">
        <button
          type="button"
          onClick={handleDecrease}
          disabled={value <= min}
          className="flex items-center justify-center w-7 h-7 text-[color:var(--vi-text-secondary)] hover:text-[color:var(--vi-text)] hover:bg-[color:var(--vi-surface-hover)] disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent transition-colors"
          title="Decrease decimals"
        >
          <Minus size={14} strokeWidth={2.5} />
        </button>
        <span className="flex items-center justify-center min-w-[26px] h-7 text-sm font-semibold text-[color:var(--vi-text)] border-x border-[color:var(--vi-card-border)] tabular-nums">
          {value}
        </span>
        <button
          type="button"
          onClick={handleIncrease}
          disabled={value >= max}
          className="flex items-center justify-center w-7 h-7 text-[color:var(--vi-text-secondary)] hover:text-[color:var(--vi-text)] hover:bg-[color:var(--vi-surface-hover)] disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent transition-colors"
          title="Increase decimals"
        >
          <Plus size={14} strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
};
